import DOMPurify from 'dompurify';

// Configure DOMPurify with rich text editor support
const purifyConfig = {
  ALLOWED_TAGS: [
    'p', 'br', 'strong', 'em', 'u', 'b', 'i', 'ul', 'ol', 'li', 
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'span', 'div', 'blockquote',
    'a', 'img', 's', 'sub', 'sup'
  ],
  ALLOWED_ATTR: [
    'class', 'style', 'href', 'target', 'rel', 'src', 'alt', 
    'width', 'height', 'title', 'data-*'
  ],
  FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover', 'onmouseout', 'onfocus', 'onblur'],
  FORBID_TAGS: ['script', 'object', 'embed', 'base', 'link', 'meta'],
  KEEP_CONTENT: true,
  ALLOW_DATA_ATTR: true,
};

// Sanitize HTML content to prevent XSS attacks
export const sanitizeHtml = (dirty: string): string => {
  if (!dirty || typeof dirty !== 'string') {
    return '';
  }
  
  return DOMPurify.sanitize(dirty, purifyConfig);
};

// Sanitize plain text (escape HTML entities)
export const sanitizeText = (text: string): string => {
  if (!text || typeof text !== 'string') {
    return '';
  }
  
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#x27;');
};

// Validate and sanitize user input
export const validateAndSanitizeInput = (input: string, maxLength: number = 1000): string => {
  if (!input || typeof input !== 'string') {
    return '';
  }
  
  // Limit input length
  const truncated = input.slice(0, maxLength);
  
  // Remove potentially dangerous patterns
  const cleaned = truncated
    .replace(/javascript:/gi, '')
    .replace(/data:/gi, '')
    .replace(/vbscript:/gi, '')
    .replace(/on\w+\s*=/gi, '');
  
  return sanitizeHtml(cleaned);
};

// Safe component for rendering HTML content
export const createSafeHtmlProps = (htmlContent: string) => ({
  dangerouslySetInnerHTML: {
    __html: sanitizeHtml(htmlContent)
  }
});